import * as ScrollArea from "@radix-ui/react-scroll-area";
import { MAIN_SIDEBAR_MENU } from "../../../constants/sidebar-menu";
import { cn } from "../../../lib/utils";
import { Link, useLocation } from "react-router-dom";
import { GoSidebarCollapse, GoSidebarExpand } from "react-icons/go";

interface SidebarProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isCollapsed, onToggle }) => {
  const { pathname } = useLocation();

  const isActiveRoute = (path: string) => {
    return pathname === path;
  };

  return (
    <section
      className={cn(
        "flex flex-col border-r border-borderColor bg-blackLight text-white sticky left-0 h-full max-sm:hidden select-none overflow-y-auto pb-42 transition-all duration-300",
        isCollapsed ? "min-w-[60px] w-[60px]" : "min-w-[240px] w-[240px]"
      )}
    >
      <ScrollArea.Root className="w-full h-full overflow-hidden relative">
        <ScrollArea.Viewport className="w-full h-full">
          <div className="mb-10 pb-2 gap-y-4">
            <div
              className={cn("flex", {
                " justify-end": !isCollapsed,
                "justify-center": isCollapsed,
              })}
            >
              <button
                className="p-2 hover:text-primary rounded-full"
                onClick={onToggle}
              >
                {isCollapsed ? (
                  <GoSidebarCollapse className="text-white hover:text-primary w-6 h-6" />
                ) : (
                  <GoSidebarExpand className="text-white hover:text-primary w-6 h-6" />
                )}
              </button>
            </div>

            {MAIN_SIDEBAR_MENU.map((item) => (
              <Link
                key={item.title}
                title={isCollapsed ? item.title : ""}
                className={cn(
                  isActiveRoute(item.path)
                    ? "bg-primary text-white"
                    : "hover:bg-black",
                  "flex items-center py-5 p-2 hover:cursor-pointer"
                )}
                to={item.path}
              >
                <item.icon className="w-6 h-6 mx-2" />

                {!isCollapsed && <p>{item.title}</p>}
              </Link>
            ))}
          </div>
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar
          className="flex select-none touch-none p-0.5 transition-colors duration-[160ms] ease-out hover:bg-black data-[orientation=vertical]:w-2.5 data-[orientation=horizontal]:flex-col data-[orientation=horizontal]:h-2.5"
          orientation="vertical"
        >
          <ScrollArea.Thumb className="flex-1 bg-scrollbarColor rounded-[10px] relative before:content-[''] before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-full before:h-full before:min-w-[44px] before:min-h-[44px]" />
        </ScrollArea.Scrollbar>
      </ScrollArea.Root>
    </section>
  );
};

export default Sidebar;
